import { v4 as uuidv4 } from "uuid";

// Stable per-install id so the recording manifest (and another device the user
// logs into) can identify which device a stuck recording is on. Created on
// first use and reused; single-sourced here so the recorder and the recovery
// banner can never disagree on this device's identity.
export const getDeviceId = () => {
  try {
    let id = localStorage.getItem("lucasDeviceId");
    if (!id) {
      id = typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : uuidv4();
      localStorage.setItem("lucasDeviceId", id);
    }
    return id;
  } catch (_) {
    return "web";
  }
};

// Human label shown in the cross-device prompt ("still on your <device>").
// Handles both the mobile-app WebView (iPhone/Android) and desktop browsers so
// one recording surface feeds a single consistent label into the manifest.
export const getDeviceLabel = () => {
  const ua = (typeof navigator !== "undefined" && navigator.userAgent) || "";
  if (/iPhone|iPad|iPod/.test(ua)) return "iPhone";
  if (/Android/.test(ua)) return "Android phone";
  let browser = "Browser";
  if (/Edg\//.test(ua)) browser = "Edge";
  else if (/Chrome\//.test(ua)) browser = "Chrome";
  else if (/Firefox\//.test(ua)) browser = "Firefox";
  else if (/Safari\//.test(ua)) browser = "Safari";
  let os = "";
  if (/Macintosh|Mac OS X/.test(ua)) os = "Mac";
  else if (/Windows/.test(ua)) os = "Windows";
  else if (/Linux/.test(ua)) os = "Linux";
  return os ? browser + " on " + os : browser;
};
